import {
	DataQuery,
	DBxEvent,
    ParserUtil,
    FontLibrary
} from "cartovista";
import { show } from "../appTools/Alerts";
import {updatePoints} from "../utils/ServerRequests";

    var transferBtnHtml = '<button id="TransferTool_transferBtn" type="button" class="btn btn-sm btn-light editionAllowed" title="Transfert : Déplacez les points sélectionnés dans dans un autre secteur"><i class="bi bi-reply-fill"></i>&nbspTransférer</button>',
        cancelTransferBtnHtml = '<button id="TransferTool_cancelTransferBtn" type="button" class="btn btn-sm btn-light editionAllowed" disabled="true" title="Annuler : Annuler le dernier transfert de points effectué"><i class="bi bi-x-lg" style="color:red;"></i>&nbspAnnuler</button>';

    export default class TransferTool {
        constructor($container){
            window.cartovista.addOneTimeEventListener(cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
            window.cartovista.addEventListener("SectorsDatastore_SectorDataCodeChanged", this._onSectorDataCodeChanged, this);
            window.cartovista.addOneTimeEventListener(C.PANELS.DECOUPAGE_PANEL.POINTS.LAYER_ID + "_layerCreated", this._onPointsLayerCreated, this);
            window.cartovista.addEventListener("AuthSession_UserLoggedIn", this._onAuthSessionUserLoggedIn, this);
            window.cartovista.addEventListener("ReloadDataTool_ReloadStarted", this._onReloadDataStarted, this);
            window.cartovista.addEventListener("ReloadDataTool_ReloadCompleted", this._onReloadDataCompleted, this);
            this._$transferBtn = $(transferBtnHtml);
            this._$cancelTransferBtn = $(cancelTransferBtnHtml);
            $container.prepend([this._$transferBtn, this._$cancelTransferBtn]);
            this._$transferBtn.click(this._onTransferBtnClicked.bind(this));
            this._$cancelTransferBtn.click(this._onCancelTransferBtnClicked.bind(this));
            this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
        }

    _onCartoVistaMapLoaded(evt) {
        this._map = window.cartovista.getMap(C.MAP.ID);
        this._map.addEventListener(this._map.EVENTS.ACTIVE_THEME_SET_CHANGED, this._onActiveThemeSetChanged, this);
    };

    _onPointsLayerCreated(evt) {
        this._pointsLayer = evt.source.layer;
        this._pointsLayerDataTable = this._pointsLayer.getDataTable(C.PANELS.DECOUPAGE_PANEL.POINTS.DATATABLE_ID);
        this._pointsLayerSumField = this._pointsLayerDataTable.getDataColumns(C.PANELS.DECOUPAGE_PANEL.POINTS.SUM_DATACOLUMN_ID)[0];
    };

    _onAuthSessionUserLoggedIn(evt) {
        this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
    };

    _toggleInputsDisabledProperty(disabled) {
        if (disabled) {
            this._$transferBtn.prop("disabled", true);
            this._$cancelTransferBtn.prop("disabled", true);
        } else {
            this._$transferBtn.prop("disabled", "");
            this._$cancelTransferBtn.prop("disabled", "");
        }
    };

    _onReloadDataStarted(evt) {
        this._toggleInputsDisabledProperty(true);
    };

    _onReloadDataCompleted(evt) {
        this._toggleInputsDisabledProperty(C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED ? false : true);
    };

    _onActiveThemeSetChanged() {
        if (C.APP_TOOLS.AUTH_SESSION.USER.EDITION_ALLOWED) {
            if (this._map.activeThemeSet) {
                this._toggleBtnDisabled(false);
            } else {
                this._toggleBtnDisabled(true);
            }
        }
    };

    _toggleBtnDisabled(bool) {
        if (bool) {
            this._$transferBtn.prop("disabled", true);
            this._$cancelTransferBtn.prop("disabled", true);
        } else {
            this._$transferBtn.prop("disabled", "");
            if (window.sectorsDataStore.getPrevEnabledSectorsData(this._map._scenarioId).length > 0) {
                this._$cancelTransferBtn.prop("disabled", "");
            } else {
                this._$cancelTransferBtn.prop("disabled", true);
            }
        }
    };

    _onTransferBtnClicked() {
        var sectorData = window.sectorsDataStore.getSelectedSector(this._map._scenarioId);
        if (typeof sectorData === "undefined") {
            show("TransferTool_TransferError_1", {"title": C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE});
        } else if (!this._pointsLayer._selection.length) {
            show("TransferTool_TransferError_2", {"title": C.LOCALES.POINTS.NAMES.SHORT_SINGLE});
        } else {
            this._pointsLayer.computeSelectionStack(function(linkingIds){
                this._transferPoints(_.cloneDeep(linkingIds), sectorData);
            }.bind(this));
        }
    };

    _savePreviousSectorData(featuresIds, sectorData) {
        //remove existing prevFeaturesIds in sectorsData
        _.forEach(window.sectorsDataStore.getPrevEnabledSectorsData(sectorData.scenario), function(prevEnabledSectorData) {
            prevEnabledSectorData.prevEnabled = false;
        });
        new DataQuery(this._pointsLayerDataTable.getDataColumns([C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[sectorData.scenario].SECTOR, C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[sectorData.scenario].GROUP]), featuresIds)
            .execute(function(result) {
                _.forEach(result.linkingIds, function(linkingId, idx) {
                    var group = result.values[C.PANELS.DECOUPAGE_PANEL.POINTS.DATATABLE_ID][C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[sectorData.scenario].GROUP][idx],
                        code = result.values[C.PANELS.DECOUPAGE_PANEL.POINTS.DATATABLE_ID][C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[sectorData.scenario].SECTOR][idx];
                    window.sectorsDataStore.getSectorsData(sectorData.scenario, group, code)._prevFeaturesIds.push(linkingId);
                });
            });
    };

    _onCancelTransferBtnClicked() {
        this._toggleBtnDisabled(true);
        var sectorsData = window.sectorsDataStore.getPrevEnabledSectorsData(this._map._scenarioId);
        if (sectorsData.length) {
            window.sectorsDataStore.setSectorsDataDirty(this._map._scenarioId);
            _.forEach(sectorsData, function(sectorData) {
                var featuresIds = sectorData.prevFeaturesIds;
                sectorData.prevEnabled = false;
                this._updatePointsDataRows(featuresIds, sectorData);
                this._updatePoints(featuresIds, sectorData);
            }.bind(this));
        } else {
            show("TransferTool_CancelTransferError", {"title": C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE});
            this._toggleBtnDisabled(false);
        }
    };

    _validateTransferGroup(featuresIds, sectorData) {
        if (C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS) {
            var sectorsDataGroup = window.sectorsDataStore.getSectorsDataGroups(sectorData.scenario, sectorData.group);
            //not transferring into another sectorDataGroup and not transferring if feature already in sectorData target
            var removedFeaturesIds = _.remove(featuresIds, function(featureId) {
                return sectorsDataGroup.featuresIds.indexOf(featureId) === -1 || sectorData.featuresIds.indexOf(featureId) !== -1;
            });
        } else {
            var extSectorData = window.sectorsDataStore.getSectorsData(sectorData.scenario, "EXT", "EXT");
            if (typeof extSectorData != "undefined") {
                //not transferring if feature is already in sectorData or in extSectorData
                var removedFeaturesIds = _.remove(featuresIds, function(featureId) {
                    return sectorData.featuresIds.indexOf(featureId) !== -1 || extSectorData.featuresIds.indexOf(featureId) !== -1;
                });
                if (removedFeaturesIds.length) {
                    show(removedFeaturesIds.length > 1 ? "TransferTool_ValidatePointsRemovedExt" : "TransferTool_ValidatePointRemovedExt", { "title": C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE, "point": C.LOCALES.POINTS.NAMES.SHORT_PLURAL, "count": removedFeaturesIds.length.toLocaleString("fr-CA"), "sectorCode": extSectorData.code, "sectorGroup": extSectorData.group});
                }
            } else {
                //not transferring if feature is already in sectorData
                var removedFeaturesIds = _.remove(featuresIds, function(featureId) {
                    return sectorData.featuresIds.indexOf(featureId) !== -1;
                });
                if (removedFeaturesIds.length) {
                    show(removedFeaturesIds.length > 1 ? "TransferTool_ValidatePointsRemoved" : "TransferTool_ValidatePointRemoved", {"title": C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE, "point": C.LOCALES.POINTS.NAMES.SHORT_PLURAL, "count": removedFeaturesIds.length.toLocaleString("fr-CA"), "sectorCode": sectorData.code, "sectorGroup": sectorData.group});
                }
            }
        }

        return featuresIds;
    };

    _onSectorDataCodeChanged(evt) {
        this._transferPoints(evt.source.featuresIds, evt.source, false, false);
    };

    _transferPoints(featuresIds, sectorData, validateTransfer, savePrevious) {
        var validateTransfer = typeof validateTransfer != "undefined" ? validateTransfer : true,
            savePrevious = typeof savePrevious != "undefined" ? savePrevious : true;
        if (validateTransfer) {
            var featuresIds = this._validateTransferGroup(featuresIds, sectorData);
        }
        if (featuresIds.length) {
            this._toggleBtnDisabled(true);
            if (C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS) {
                window.sectorsDataStore.setSectorsDataDirty(sectorData.scenario, sectorData.group);
            } else {
                window.sectorsDataStore.setSectorsDataDirty(sectorData.scenario);
            }
            if (savePrevious) {
                this._savePreviousSectorData(featuresIds, sectorData);
            }
            this._updatePointsDataRows(featuresIds, sectorData);
            this._updatePoints(featuresIds, sectorData);
        } else {
            this._toggleBtnDisabled(false);
        }
    };

    //TODO selection par légende est brisée après update
    _updatePointsDataRows(featuresIds, sectorData) {
        var column = this._pointsLayerDataTable.getDataColumns([C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[sectorData.scenario].THEME])[0];
        this._pointsLayerDataTable.updateValues(column, featuresIds, _.fill(Array(featuresIds.length), sectorData.themeIndValue));
        column = this._pointsLayerDataTable.getDataColumns([C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[sectorData.scenario].SECTOR])[0];
        this._pointsLayerDataTable.updateValues(column, featuresIds, _.fill(Array(featuresIds.length), sectorData.code));
        if (C.PANELS.DECOUPAGE_PANEL.TWO_LEVELS) {
            column = this._pointsLayerDataTable.getDataColumns([C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[sectorData.scenario].GROUP])[0];
            this._pointsLayerDataTable.updateValues(column, featuresIds, _.fill(Array(featuresIds.length), sectorData.group));
        }
    };

    _getFeaturesData(featuresIds, sectorData) {
        var featuresData = _.map(featuresIds, function(featureId) {
            var featureData = {"attributes" : {}, "geometry" : null};
            featureData["attributes"]["GUID"] = featureId;
            featureData["attributes"][C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[sectorData.scenario].SECTOR] = sectorData.code;
            featureData["attributes"][C.PANELS.DECOUPAGE_PANEL.POINTS.SCENARIOS_DATACOLUMNS[sectorData.scenario].GROUP] = sectorData.group;
            return featureData;
        });
        return featuresData;
    };

    _getQueryExpression(featuresIds) {
        return {
            "LOGICAL_OPERATOR" : null,
            "QUERIES" : [
                {"FIELD" : "GUID", "OPERATOR" : (featuresIds.length > 1 ? "IN" : "="), "VALUE" : (featuresIds.length > 1 ? featuresIds : featuresIds[0])},
            ]
        };
    };

    _updatePoints(featuresIds, sectorData) {
        Promise.all(_.map(_.chunk(featuresIds, 999), function(chunk) {
            return updatePoints(this._getQueryExpression(chunk), this._getFeaturesData(chunk, sectorData));
        }.bind(this))).then(function(guids) {
            window.cartovista.dispatchEvent(new DBxEvent("TransferTool_TransferCompleted", featuresIds));
            this._toggleBtnDisabled(false);
            var sum = this._getTransferSum(featuresIds);
            show(featuresIds.length > 1 ? "TransferTool_PointsUpdated" : "TransferTool_PointUpdated", {"title": C.LOCALES.SECTORS.SECTOR.NAMES.SHORT_SINGLE, "point": C.LOCALES.POINTS.NAMES.SHORT_SINGLE, "count": featuresIds.length.toLocaleString("fr-CA"), "sum": sum.toLocaleString("fr-CA"), "sectorCode": sectorData.code});
        }.bind(this));
    };

    _getTransferSum(featuresIds) {
        var sum;
        var query = new DataQuery([this._pointsLayerSumField], featuresIds, ["SUM"])
        query.useDataFilters = false;
        query.execute(function(result) {
            sum = result.statisticsValues[this._pointsLayerDataTable.id][this._pointsLayerSumField.id].SUM;
        }, this);
        return sum;
    };

}
